import { Injectable } from "@angular/core";
import { AbstractService } from "../core/AbstractService";
import { ModePassationMarcheReq } from "../data/http/requests/modepassationmarche.req";
import { ModePassationMarcheRes } from "../data/http/responses/modepassationmarche.res";
import { HttpClient } from "@angular/common/http";
import { AppService } from "../core/app.service";
import { env } from "../../env/env";


@Injectable({
    providedIn: 'root'
})
export class ModePassationMarcheService extends AbstractService<ModePassationMarcheReq, ModePassationMarcheRes> {
    constructor(http: HttpClient, appService: AppService) {
        super(`${env.apiUrl}mode-passation-marche`, http, null, appService); 
    }
}